module.exports = __webpack_public_path__ + "img/junior-virtual-2022-robomission.95171a51.png";